import React from 'react';
import { IconSendingFailed } from '../../../../src/assets/images';

function SendingFailed() {
    return (
        <div className="sendingFailed">
            <IconSendingFailed />
        </div>
    );
}

export default SendingFailed;
